import { ErrorCode } from '@colyseus/sdk'

/**
 * Why the client has no room and is not retrying (T1.8 menu errors). `not-found`: wrong or
 * expired code; `full`: the room is full or its race already started; `auth`: the server
 * refused the token; `duplicate`: this user already has a seat in that room (another tab, D-034);
 * `kicked`: input abuse (`CLOSE_KICKED`); `lost`: the race reconnection gave up; `network`: the
 * server could not be reached.
 */
export type LeaveReason =
  'not-found' | 'full' | 'auth' | 'duplicate' | 'kicked' | 'lost' | 'network'

/**
 * Classify a matchmaking error that a retry cannot fix, or null when it is worth retrying.
 * The server sends `MATCHMAKE_INVALID_ROOM_ID` for a wrong code, a started race (D-033) and a
 * second seat for the same user (`already in this room`, D-034); Colyseus sends it for a locked
 * (full or started), missing or disposed room.
 */
export function refusalReason(err: unknown): LeaveReason | null {
  const e = err as { code?: unknown; message?: unknown } | null
  const message = typeof e?.message === 'string' ? e.message : ''
  if (e?.code === ErrorCode.AUTH_FAILED) return 'auth'
  if (e?.code !== ErrorCode.MATCHMAKE_INVALID_ROOM_ID) return null
  if (/already in this room/i.test(message)) return 'duplicate'
  return /locked|started|full/i.test(message) ? 'full' : 'not-found'
}
